import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App"; // ✅ fixed this line
import './index.css';

<link href="https://fonts.googleapis.com/css2?family=Nunito:wght@600&display=swap" rel="stylesheet" />





const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
